export default "__VITE_ASSET__f735a387__"